/**
 * Surface-specific helper text for BookingPurpose fields.
 * Purpose is selected independently on request / event / hall slot / lagat —
 * these strings explain what each surface drives so staff do not conflate them.
 */
export const PURPOSE_HELPER_TEXT = {
  /** Raza request — defaults for request lagat and new events. */
  razaRequest:
    "Defaults lagat receipts and new events on this request. Hall slots and calendar titles use their own purpose fields.",

  /**
   * Raza event — per-event lagat must match; also feeds calendar title when Title is empty.
   */
  razaEvent:
    "Used for per-event lagat (receipt purpose must match). Also sets the Google Calendar title when Title is empty.",

  /** Hall slot — rent/deposit via PurposeHallCharge for the selected hall. */
  hallSlot:
    "Sets rent, deposit, and other hall charges for this slot from the purpose's hall charge table.",

  /** Lagat receipt — must match the event for per-event lagat. */
  lagatReceipt:
    "For per-event lagat, this must match the event's purpose. Request-level lagat can use the request purpose.",
} as const;

export type PurposeHelperSurface = keyof typeof PURPOSE_HELPER_TEXT;

export function purposeHelperText(surface: PurposeHelperSurface): string {
  return PURPOSE_HELPER_TEXT[surface];
}
